import styled from 'styled-components';
import { InputWrapper } from '../input/styles';
import { theme } from '../globalStyle/global-styles';

export const TextareaWrapper = styled(InputWrapper)`
  /* margin-bottom: ${theme.space_size}; */
  textarea {
    width: 100%;
    height: 152px;
    border: none;
    resize: none;
    font-family: ${theme.fonts.Medium};
    font-size: 13px;
    color: ${theme.colours.blackText};
    background-color: ${theme.colours.white};
    padding: 12px;
    border: 1px solid ${theme.colours.SpanishGray};
    border-radius: 6px;
    &:focus {
      font-size: 13px;
    }
    &::placeholder {
      color: ${theme.colours.Nickel} !important;
    }
  
    outline: none;
  }
  .label {
      line-height: 0;
      p {
        display: inline-block;
        line-height: 22px;
        span {
          color: ${theme.colours.error};
          font-size: 15px;
        }
      }
    }
  textarea.hasError {
    border: 1px solid ${theme.colours.error} !important;
  }
`;
